import { z } from 'zod';

export const ContactUsFormSchema = z.object({
	consent:   z.literal(true, { error: 'You must agree to the privacy policy' }),
	email:     z.string().min(1, 'Email is required').email('Invalid email address'),
	firstName: z.string().min(1, 'First name is required'),
	lastName:  z.string().min(1, 'Last name is required'),
	message:   z.string().min(1, 'Message is required').max(500, 'Message must be at most 500 characters'),
	reason:    z.string(),
});
export type ContactUsFormModel = z.infer<typeof ContactUsFormSchema>;
